export const TEXT_SIZES = {
  XSMALL: "xsmall",
  SMALL: "small",
  MEDIUM: "medium",
  LARGE: "large",
} as const;

export const TEXT_LINE_HEIGHTS = {
  short: "short",
  long: "long",
} as const;

export const HEX_COLOR_PATTERN = /#(?:[0-9a-fA-F]{3}){1,2}\b/g;
export const DIRECTION_REGEX = /linear-gradient\(([\d.]+)deg/;
export const DEFAULT_BG_COLOR = "#ACB3B9";

export const SPECIAL_OFFER_ANALYTICS_ACTION_NAMES = {
  SPECIAL_OFFER_LANDING_CAROUSEL_OPEN: "placementCarouselOpen",
  SPECIAL_OFFER_LANDING_CAROUSEL_CLOSE: "placementCarouselClose",
  SPECIAL_OFFER_LANDING_CAROUSEL_RIGHT_BUTTON_CLICK:
    "placementCarouselRightClick",
  SPECIAL_OFFER_LANDING_CAROUSEL_LEFT_BUTTON_CLICK:
    "placementCarouselLeftClick",
  SPECIAL_OFFER_LANDING_CAROUSEL_ITEM_SHOW: "placementCarouselItemShow",
  SPECIAL_OFFER_LANDING_CAROUSEL_ITEM_BUTTON_CLICK:
    "placementCarouselItemButtonClick",
} as const;

export const SPECIAL_OFFER_SNOWPLOW_ANALYTICS_ACTION_NAMES = {
  SPECIAL_OFFER_LANDING_CAROUSEL_CLOSE: "PlacementClose",
  SPECIAL_OFFER_LANDING_CAROUSEL_RIGHT_BUTTON_CLICK: "PlacementRightClick",
  SPECIAL_OFFER_LANDING_CAROUSEL_LEFT_BUTTON_CLICK: "PlacementLeftClick",
  SPECIAL_OFFER_LANDING_CAROUSEL_ITEM_SHOW: "PlacementOpen",
  SPECIAL_OFFER_LANDING_CAROUSEL_ITEM_BUTTON_CLICK: "PlacementButtonClick",
} as const;

export const CLICK_EVENT_NAME = "click";
